import LoadingIndicator from 'Components/reusable/LoadingIndicator'
import { useLogin, useUser } from 'hooks'
import { Navigate, Outlet, useLocation } from 'react-router'

const ProtectedRoute = () => {
  const { loginLoading, loggedIn } = useLogin()
  const { ready, features } = useUser()
  const location = useLocation()

  if (loginLoading) {
    return <LoadingIndicator />
  }

  if (!loggedIn) {
    const redirectUrl = `${location.pathname}${location.search}${location.hash}`
    return <Navigate replace to="/login" state={{ url: redirectUrl }} />
  }

  if (!ready && features.length === 0) {
    return <LoadingIndicator />
  }

  return <Outlet />
}

export default ProtectedRoute
